import { useFooter } from '../../store/FooterContext';
import './Footer.css';

const Footer = () => {
  const { footerData = {} } = useFooter();

  const {
    copyright = "© 2025-2026 GLUE ID, Inc. All Rights Reserved | For Internal Use Only",
    linkedin = "https://www.linkedin.com/company/noeticpartners",
    email = "sales@noeticpartners.com"
  } = footerData;

  return (
    <footer className="footer">
      <div className="container">

        {/* Row 1 */}
        <div className="text-sm">
          {copyright}
        </div>

        {/* Row 2 */}
        <div className="links">
          <span className="text-sm">Connect with Sales :</span>

          {/* 🔷 LinkedIn SVG (clean + centered) */}
          {linkedin && (
            <a
              href={linkedin}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M19 0h-14C2.24 0 0 2.24 0 5v14c0 2.76 2.24 5 5 5h14c2.76 0 
                         5-2.24 5-5V5c0-2.76-2.24-5-5-5zM8.339 19.337H5.337V9.337h3.002
                         v10zm-1.5-11.4c-.957 0-1.732-.775-1.732-1.732s.775-1.732 
                         1.732-1.732c.956 0 1.731.775 1.731 1.732s-.775 1.732-1.731 
                         1.732zM20 19.337h-3.002v-5.004c0-1.191-.022-2.724-1.66-2.724
                         -1.662 0-1.917 1.297-1.917 2.639v5.089H10.42V9.337h2.884v1.37h.041
                         c.402-.761 1.386-1.562 2.854-1.562 3.05 0 3.601 2.008 
                         3.601 4.621v5.571z" />
              </svg>
            </a>
          )}

          {email && (
            <a
              href={`mailto:${email}`}
              aria-label="Email Sales"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M20 4H4C2.897 4 2.009 4.897 
                         2.009 6L2 18c0 1.103.897 2 2 
                         2h16c1.103 0 2-.897 
                         2-2V6c0-1.103-.897-2-2-2zm0 
                         4-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
            </a>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;